// extracted by mini-css-extract-plugin
var _1 = "SidebarSection-module__animateUploadProgressBarWidth--oB84V";
var _2 = "SidebarSection-module__animatedBackground--nlR9p";
var _3 = "SidebarSection-module__container--Fjhl0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
